import { Component, ReactNode } from 'react';
import { Translation } from 'react-i18next';



interface ErrorBoundaryProps {
	children: ReactNode
}

interface ErrorBoundaryState {
	hasError: boolean,
	errorMessage: string | undefined,
	errorStack: string | undefined
}


class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = {
			hasError: false,
			errorMessage: undefined,
			errorStack: undefined
		};
	}

	static getDerivedStateFromError(error: Error) {
		return { hasError: true, errorMessage: error.message, errorStack: error.stack };
	}

	override componentDidCatch(error: Error, errorInfo: any) {
		console.error('Error boundary Error');
		console.error(`Details:\nError Info: ${errorInfo}\nError: ${error}\nEnvironment: ${process.env.ENV}`);
	}

	override render() {
		if (this.state.hasError) {
			return (
				<Translation ns='global'>{( t ) =>
					<div className='components-error-boundary'>
						<h1>{t('pages.errorHeader')}</h1>

						<p className='error-label'>{t('pages.errorText')}</p>
					</div>
				}</Translation>
			);
		};
		return this.props.children;
	}
}

export default ErrorBoundary;